const translation = {
  nav_home: "الرئيسية",
  nav_contracts: "العقود",
  nav_calculator: "الحاسبة",
  nav_analysts: "المحللون",
  nav_benefits: "المزايا",
  nav_about: "عنا",
  nav_contact: "اتصل بنا",

  hero_badge: "فرصة عاجلة",
  hero_title1: "أزمة إيران",
  hero_title2: "فرصتك",
  hero_title3: "للربح",
  hero_subtitle: "20% من النفط العالمي محجوب. أسعار برنت ترتفع. تصرف الآن.",
  hero_cta1: "عرض العقود",
  hero_cta2: "اعرف المزيد",

  contracts_title: "اختر عقدك",
  contracts_subtitle: "ثلاثة مستويات استثمارية بعوائد مضمونة",
  contract_basic: "أساسي",
  contract_popular: "الأكثر شعبية",
  contract_pro: "احترافي",
  contract_investment: "الاستثمار",
  contract_profit: "ربحك",
  contract_total: "إجمالي ما ستحصل عليه",
  contract_yield: "العائد",
  contract_start: "ابدأ",
  contract_choose: "اختر الآن",
  contract_maximize: "زيادة الأرباح",
  contract_disclaimer: "* العوائد مبنية على ظروف السوق الحالية والبيانات التاريخية. الاستثمارات تنطوي على مخاطر.",

  calc_title: "حاسبة الأرباح",
  calc_subtitle: "اكتشف كم يمكنك كسبه مع كل عقد",
  calc_investment: "استثمارك:",
  calc_yield: "العائد:",
  calc_profit: "ربحك:",
  calc_total: "الإجمالي الذي ستحصل عليه:",
  calc_basic_label: "المستوى الأساسي",
  calc_popular_label: "الخيار الشعبي",
  calc_max_label: "أقصى ربح",
  calc_double: "تضاعف أموالك!",
  calc_2_5: "تحصل على 2.5 ضعف أكثر!",
  calc_3x: "تحصل على أكثر من 3 أضعاف!",
  calc_best: "أفضل عرض",
  calc_cta_title: "كلما استثمرت أكثر، كلما ربحت أكثر!",
  calc_cta_sub: "عقودنا مصممة لتعظيم أرباحك في ظل الأزمة الحالية",
  calc_cta_btn: "ابدأ الكسب",

  analysts_badge: "فريقنا",
  analysts_title: "خبراء بـ",
  analysts_title_accent: "وصول حصري",
  analysts_subtitle: "هؤلاء المتخصصون يمنحونك الوصول إلى أفضل عقود النفط ويقودونك نحو أقصى ربح.",
  analyst_contact: "تواصل مع",

  analyst1_name: "نيكولاي إيليف",
  analyst1_role: "كبير المحللين الماليين",
  analyst1_desc: "نيكولاي خبير رائد في مجال استثمارات النفط بخبرة تزيد عن 15 عامًا. متخصص في تحليل المخاطر الجيوسياسية وتأثيرها على أسعار النفط الخام.",
  analyst1_exp: "خبرة 15+ سنة",
  analyst1_clients: "300+ عميل",

  analyst2_name: "ديميتار ستويانوف",
  analyst2_role: "كبير محللي أسواق النفط",
  analyst2_desc: "ديميتار متخصص في التحليل الفني لأسواق النفط. يطور استراتيجيات لتعظيم العوائد في ظروف السوق المتقلبة.",
  analyst2_exp: "خبرة 12+ سنة",
  analyst2_clients: "250+ عميل",

  analyst3_name: "إيفان ستويانوف",
  analyst3_role: "محلل أسواق الطاقة",
  analyst3_desc: "يركز إيفان ستويانوف على تحليل أسواق الطاقة العالمية. متخصص في تحديد فرص الاستثمار في أوقات الأزمات.",
  analyst3_exp: "خبرة 10+ سنوات",
  analyst3_clients: "200+ عميل",

  analyst4_name: "ميغلينا ستانيفا",
  analyst4_role: "مستشارة مالية",
  analyst4_desc: "ميغلينا مستشارة مالية معتمدة بخبرة واسعة في إدارة محافظ الاستثمار. تقدم استراتيجيات مخصصة لكل عميل.",
  analyst4_exp: "خبرة 8+ سنوات",
  analyst4_clients: "180+ عميل",

  analyst5_name: "نيكولاس ستانيف",
  analyst5_role: "محلل أسواق السلع",
  analyst5_desc: "نيكولاس ستانيف متخصص في تحليل أسواق السلع مع التركيز على النفط والغاز الطبيعي. يطور توقعات دقيقة لحركة الأسعار.",
  analyst5_exp: "خبرة 11+ سنة",
  analyst5_clients: "220+ عميل",

  analyst6_name: "ستيفان مينتشيف",
  analyst6_role: "استراتيجي الاستثمار",
  analyst6_desc: "ستيفان مينتشيف استراتيجي استثمار متمرس متخصص في قطاع النفط. يساعد العملاء على تحقيق أقصى عائد من خلال استراتيجيات استثمار محسّنة.",
  analyst6_exp: "خبرة 9+ سنوات",
  analyst6_clients: "190+ عميل",

  benefits_title: "لماذا تختارنا",
  benefits_subtitle: "مزايا الاستثمار في عقود نفط برنت",
  benefit1_title: "عوائد عالية",
  benefit1_desc: "احصل على ربح من 100% إلى 210% بفضل الوضع الجيوسياسي الحالي وارتفاع أسعار النفط",
  benefit2_title: "الأمان",
  benefit2_desc: "جميع المعاملات محمية، والعقود موثقة قانونيًا، واستثماراتك تحت حماية موثوقة",
  benefit3_title: "دعم الخبراء",
  benefit3_desc: "فريق من 6 محللين ماليين معتمدين بسنوات من الخبرة في سوق النفط",
  benefit4_title: "بداية سريعة",
  benefit4_desc: "عملية تسجيل وتفعيل عقد بسيطة. ابدأ الكسب اليوم",
  benefit5_title: "السوق العالمي",
  benefit5_desc: "الوصول إلى عقود نفط برنت الدولية على المستوى المؤسسي",
  benefit6_title: "الشفافية",
  benefit6_desc: "تقارير منتظمة وتحليلات وشفافية كاملة لجميع العمليات والنتائج",

  about_map_title: "مضيق هرمز محجوب",
  about_map_sub: "من النفط العالمي",
  about_title: "الأزمة تخلق الفرص",
  about_p1: "أدى النزاع في إيران إلى إغلاق مضيق هرمز — المسار الحيوي الذي يمر عبره 20% من إمدادات النفط العالمية.",
  about_p2: "تسبب ذلك في ارتفاع حاد في أسعار نفط برنت، مما يخلق فرصة فريدة للمستثمرين لتحقيق أرباح كبيرة من خلال عقود نفط متخصصة.",
  about_p3: "يستمر عدم الاستقرار الجيوسياسي في التأثير على السوق ويتوقع الخبراء مزيدًا من ارتفاع الأسعار في الأشهر القادمة.",
  about_cta: "تعلم الاستراتيجية",

  contact_title: "مستعد للبدء؟",
  contact_subtitle: "تواصل مع نيكولاي إيليف وابدأ رحلتك الاستثمارية اليوم. أماكن محدودة للمستثمرين الجدد.",
  contact_website: "الموقع الرسمي",
  contact_hours: "ساعات العمل",
  contact_hours_weekdays: "الاثنين – الجمعة: 9:00 – 18:00",
  contact_hours_saturday: "السبت: 10:00 – 14:00",
  contact_security: "الأمان والثقة",
  contact_security_desc: "جميع المعاملات محمية وسرية",
  contact_team_title: "اختر محللك",
  contact_team_sub: "6 متخصصين ماليين مرخصين",
  contact_team_desc: "تعرف على فريق خبرائنا واختر المحلل الذي تريد العمل معه. كل منهم يقدم نهجًا شخصيًا ووصولًا مباشرًا لعقود نفط برنت.",
  contact_btn: "تواصل مع نيكولاي إيليف",
  contact_btn_sub: "كبير المحللين الماليين بخبرة 15+ سنة",
  contact_choose_analyst_btn: "اختر محللك الشخصي",
  contact_choose_analyst_sub: "6 متخصصين مرخصين — ابحث عن خبيرك الشخصي",
  contact_stat_analysts: "محللون",
  contact_stat_clients: "عملاء",
  contact_stat_yield: "أقصى عائد",

  footer_tagline: "لا تفوت فرصة الاستفادة من الوضع السوقي الحالي.",
  footer_nav: "التنقل",
  footer_social: "تواصل",
  footer_contact: "اتصل بنا",
  footer_contact_desc: "للمزيد من المعلومات والتواصل المباشر مع نيكولاي إيليف:",
  footer_rights: "© 2026 Brent Oil Investment. جميع الحقوق محفوظة.",
  footer_terms: "شروط الاستخدام",
  footer_privacy: "سياسة الخصوصية",
  footer_disclaimer: "الاستثمار في عقود النفط ينطوي على مخاطر. النتائج السابقة لا تضمن الأرباح المستقبلية. يرجى الاستثمار بمسؤولية.",
};

export default translation;
